// extracted by mini-css-extract-plugin
export default {"sm_cir":"PWizard_sm_cir__SAVyT","dotted":"PWizard_dotted__xUd0W","big_cir":"PWizard_big_cir__YBMmc"};